export default (a, b) => {
  if (a.isDefault) return -1;
  if (b.isDefault) return 1;

  if (a.lastUpdated > b.lastUpdated) return -1;
  if (a.lastUpdated < b.lastUpdated) return 1;

  return 0;
};
